import Radio from "../UI/Radio";
import RadioGroup from "../UI/RadioGroup";
import Select from "../UI/Select";
import TextInput from "../UI/TextInput";
import TextArea from "../UI/TextArea";
import FormUpload from "../File/FormUpload";
import Tooltip from "../UI/Tooltip";
import { Interrogation } from "../UI/Icons";
import { TypeSociete } from "../../models/profile";
import { useFormikContext } from "formik";
import { upperCaseFirstLetter } from "../../models/utils";
import SiretFields from "../UI/SiretFields";

export default function ProfileFormPerso({
  type,
  isBailleur,
  cautionType,
  isGarant,
  profile,
  withMandatoryFields,
  prefix = "",
  isMandataire,
  isCandidat = false,
  hideTypeSelection = false,
  hideUpload = false,
  hideTitle = false,
}) {
  const formType = type === "2" ? "du représentant légal" : "";

  const { handleChange } = useFormikContext();

  return (
    <>
      {!hideTitle && <h3>Informations personnelles</h3>}
      <div>
        {!hideTypeSelection && (
          <RadioGroup className={"marginB10"}>
            <Radio name={`${prefix}type`} value="1" label="Personne physique" />
            <Radio name={`${prefix}type`} value="2" label="Personne morale" />
          </RadioGroup>
        )}
        <div className={"flex gap10"}>
          <TextInput
            type="text"
            name={`${prefix}prenom`}
            placeholder={"Nicolas"}
            label={"Prénom " + formType}
            mandatory
            className={"flex-grow"}
            onChange={(e) => {
              e.target.value = upperCaseFirstLetter(e.target.value || "");
              handleChange(e);
            }}
          />
          <TextInput
            type="text"
            name={`${prefix}nom`}
            placeholder={"Dupont"}
            label={"Nom " + formType}
            className={"flex-grow"}
            mandatory
            onChange={(e) => {
              e.target.value = e.target.value.toUpperCase();
              handleChange(e);
            }}
          />
        </div>
        <TextInput
          type="email"
          name={`${prefix}mail`}
          placeholder="adresseemail@qalimo.fr"
          label={
            <>
              Adresse e-mail{" "}
              {!withMandatoryFields && isBailleur && (
                <Tooltip
                  content={
                    "Si votre locataire n'a pas d'adresse e-mail, indiquez la votre."
                  }
                >
                  <Interrogation />
                </Tooltip>
              )}
            </>
          }
          mandatory
        />
        <TextInput
          type="text"
          name={`${prefix}tel`}
          placeholder="0622244432"
          label="Téléphone"
          mandatory={!!withMandatoryFields}
        />
        {type === "1" && (
          <div>
            <TextInput
              type="date"
              name={`${prefix}birthday`}
              placeholder="07/07/1990"
              label="Date de naissance"
              mandatory={!!withMandatoryFields}
            />
            <TextInput
              type="text"
              name={`${prefix}lieu_naissance`}
              placeholder="Paris"
              label="Lieu de naissance"
              mandatory={!!withMandatoryFields}
            />
            {!isBailleur && (
              <TextInput
                type="text"
                name={`${prefix}nationalite`}
                placeholder="Francaise"
                label="Nationalité"
                mandatory={!!withMandatoryFields}
              />
            )}
          </div>
        )}
        {type === "2" && (
          <div>
            <Select label="Type de société" name={`${prefix}socType`} mandatory>
              <option value="">Selectionnez un type</option>
              <option value={TypeSociete.SA}>SA</option>
              <option value={TypeSociete.SAS}>SAS</option>
              <option value={TypeSociete.SASU}>SASU</option>
              <option value={TypeSociete.SCA}>SCA</option>
              <option value={TypeSociete.SCI}>SCI</option>
              <option value={TypeSociete.SARL}>SARL</option>
              <option value={TypeSociete.SARL_FAMILLE}>SARL de famille</option>
              <option value={TypeSociete.SNC}>SNC</option>
              <option value={TypeSociete.ASSOCIATION}>Association</option>
              <option value={TypeSociete.EURL}>EURL</option>
              <option value={TypeSociete.ENTREPRISE_INDIVIDUELLE}>
                Entreprise individuelle
              </option>
              <option value={TypeSociete.AUTRE}>Autre</option>
            </Select>
            {isBailleur ? (
              <TextInput
                type="text"
                name={`${prefix}nom_societe`}
                placeholder="SCI RD"
                label="Dénomination sociale"
                mandatory
              />
            ) : (
              <SiretFields
                namePrefix={prefix}
                nameSiret="siret"
                nameNomSociete="nom_societe"
                nameAdresse="adresse"
                nameVille="ville"
                nameCp="cp"
                nameNom="nom"
                namePrenom="prenom"
                label="SIRET / Nom de l'entreprise"
                placeholder="12345678901234 ou Nom de l'entreprise"
                mandatory
              />
            )}
            {!isBailleur && !isMandataire && (
              <TextInput
                type="text"
                name={`${prefix}numero_tva`}
                label="N° TVA intracommunautaire"
                placeholder="FR70911182582"
              />
            )}
          </div>
        )}
        {type !== "2" &&
          !isBailleur &&
          !isGarant &&
          !profile?.garantor_of &&
          !isMandataire && (
            <>
              <Select name={`${prefix}caution_type`} label={"Type de garantie"}>
                <option value={""}>Choisissez un type de garantie</option>
                <option value={"Physique"}>Garant physique</option>
                <option value={"Visale"}>Visale</option>
                <option value={"GLI"}>Assurance loyers impayés (GLI)</option>
                <option value={"Autre"}>Autre</option>
              </Select>
              {cautionType === "Physique" && (
                <p className={"secondaryText marginB10"}>
                  Vous pourrez ajouter les informations concernant votre garant
                  après avoir complété votre profil
                </p>
              )}
              {(cautionType === "Autre" || cautionType === "GLI") && (
                <TextInput
                  type={"text"}
                  name={`${prefix}contract_number`}
                  label={"Numéro de contrat (si nécessaire)"}
                />
              )}
              {cautionType === "Visale" && (
                <>
                  <TextInput
                    type={"text"}
                    name={`${prefix}contract_number`}
                    label={"Numéro de visa VISALE"}
                  />
                  <TextInput
                    type={"number"}
                    step={"0.01"}
                    name={`${prefix}loyer_max_visale`}
                    label={"Montant maximum garanti"}
                  />
                  <TextInput
                    type={"date"}
                    name={`${prefix}validite_visale`}
                    label={"Date de validité du visa"}
                  />
                </>
              )}
              {isCandidat && (
                <TextArea
                  name={`${prefix}presentation`}
                  label={"Présentez-vous au bailleur (facultatif)"}
                  placeholder={
                    "Votre situation, vos motivations, la date d'emménagement souhaitée, un animal de compagnie…"
                  }
                  rows={4}
                  maxLength={2000}
                />
              )}
            </>
          )}
        {!isBailleur && !isMandataire && !hideUpload && (
          <>
            Justificatif d'identité
            <FormUpload tag="identite" shouldWatermark />
          </>
        )}
      </div>
    </>
  );
}
